import React from 'react';

import { twMerge } from 'tailwind-merge';

export interface VideoProps {
  className?: string;
  videoPreviewImageURL?: string;
  videoURL?: string;
}

const VideoPreview: React.FC<VideoProps> = (props) => {
  const { className, videoPreviewImageURL, videoURL } = props;

  const containerClassNames = twMerge(
    'rounded-lg shadow-6 overflow-hidden',
    'flex justify-center items-center',
    'border border-gray100 hover:bg-white',
    'h-px-176 w-px-320',
    className,
  );

  return (
    <div>
      <div className={containerClassNames}>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video controls poster={videoPreviewImageURL}>
          <source type="video/mp4" src={videoURL} />
        </video>
      </div>
    </div>
  );
};

export default VideoPreview;
